function doResize() {
  setTimeout(function() {
    //手动触发窗口resize事件
    if (document.createEvent) {
      var event = document.createEvent('HTMLEvents');
      event.initEvent('resize', true, true);
      window.dispatchEvent(event);
    } else if (document.createEventObject) {
      window.fireEvent('onresize');
    }
  }, 100);
}

export default doResize;
